import PropTypes from "prop-types";
import React from "react";

const SEO = ({ title }) => {
  return (
    <>
      <meta charSet="utf-8" />
      <title>{title} | PepperLabs</title>
      <meta name="robots" content="noindex, follow" />
      <meta
        name="description"
        content="K-Youth | PepperLabs – K-Development Programme (K-Youth) is an initiative spearheaded by Khazanah Nasional Berhad (Khazanah) that strives to cultivate Malaysia’s prospective talents. Tailored to equip young individuals with practical skills and valuable experience, this program seeks to empower them to bolster their employability.
        Enrol in our 4-month talent development program that offers a prestigious certification while you acquire priceless skills and practical experiences through our learning programme and on-the-job training with leading industrial partners affiliated with Pepper Labs."
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />

      <meta property="og:title" content={`${title} | PepperLabs`} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://pepperlabs/k-youth/" />
      <meta
        property="og:image"
        content="https://pepperlabs.my/k-youth/assets/pepper-labs-logo/k-youth-logo.png"
      />
    </>
  );
};
SEO.propTypes = {
  title: PropTypes.string,
};

export default SEO;
